var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"autoplay":"","muted":"","controls":"","controlsList":"nodownload"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.video_src,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }